import { Box, Grid, Tab, Tabs, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import * as React from "react";
import useUpgradeRequests from "../../hooks/useUpgradeRequest";
import Loader from "../Loader";
import UpgradeItem from "../UpradeRequest/UpgradeItem";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function UpgradeRequest() {
  const [value, setValue] = React.useState(0);
  const { loading, error, upgradeRequests } = useUpgradeRequests();
  const [pendingL, setPendingL] = React.useState([]);
  const [successL, setSuccessL] = React.useState([]);

  React.useEffect(() => {
    let pL = [];
    let sL = [];

    upgradeRequests.map((c) => {
      if (c?.state === "pending") {
        pL.push(c);
      } else if (c.state === "success") {
        sL.push(c);
      }
    });

    setPendingL(pL);
    setSuccessL(sL);
  }, [upgradeRequests]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (loading) {
    return <Loader loading={loading} />;
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="New Request" {...a11yProps(0)} />
          <Tab label="Done" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Grid container spacing={5}>
          {pendingL?.map((cs) => (
            <Grid item xs={12} sm={12} md={6}>
              <UpgradeItem upgrade={cs} done={false} />
            </Grid>
          ))}
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Grid container spacing={5}>
          {successL?.map((cs) => (
            <Grid item xs={12} sm={12} md={6}>
              <UpgradeItem upgrade={cs} done={true} />
            </Grid>
          ))}
        </Grid>
      </TabPanel>
    </Box>
  );
}
